import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MdLocationOn } from "react-icons/md";

import homeLogo from "../../Assets/Hacker-bro.svg";
import resume from "../../Assets/Stephen_Onyango_CV.pdf";

import Type from "./Type";
import About from "../About/About";
import Skills from "../Skills/Skills";
import CyberRange from "../CyberRange/CyberRange";
import Projects from "../Projects/Projects";
import Experience from "../Experience/Experience";
import ProfessionalDevelopment from "../ProfessionalDevelopment/ProfessionalDevelopment";
import Contact from "../Contact/Contact";

import "./Home.css";

function Home() {
  const [imageError, setImageError] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div>
      <section id="home">
        <Container fluid className="home-section">
          <Container className="home-content">
            <Row className="align-items-center flex-column-reverse flex-lg-row">
              <Col
                lg={7}
                md={12}
                className="home-header text-center text-lg-start"
              >
                <div
                  style={{
                    opacity: isVisible ? 1 : 0,
                    transform: isVisible
                      ? "translateY(0)"
                      : "translateY(20px)",
                    transition: "all 0.6s ease"
                  }}
                >
                  <h1 className="heading">
                    Hi There{" "}
                    <span aria-hidden="true">👋</span>
                  </h1>

                  <h2 className="heading-name">
                    I&apos;M{" "}
                    <span className="main-name">
                      STEPHEN ONYANGO
                    </span>
                  </h2>

                  <div className="typewriter-container">
                    <Type />
                  </div>

                  <p className="sub-heading-name">
                    IT Professional specializing in technical support,
                    systems administration, enterprise networking, business
                    applications, and cybersecurity. I build and support
                    reliable IT environments across users, devices,
                    networks, and business systems.
                  </p>

                  <div className="hero-metrics justify-content-center justify-content-lg-start">
                    <div className="hero-metric">
                      <span className="metric-number">7</span>
                      <span className="metric-label">
                        Network Segments
                      </span>
                    </div>

                    <div className="hero-metric">
                      <span className="metric-number">6+</span>
                      <span className="metric-label">
                        Core Platforms
                      </span>
                    </div>

                    <div className="hero-metric">
                      <span className="metric-number">Secure</span>
                      <span className="metric-label">
                        Remote Access
                      </span>
                    </div>
                  </div>

                  <div className="info-row justify-content-center justify-content-lg-start">
                    <div className="location-badge">
                      <MdLocationOn
                        className="location-icon"
                        aria-hidden="true"
                      />

                      <span>Nairobi, Kenya</span>
                    </div>

                    <a
                      href={resume}
                      download="Stephen_Onyango_CV.pdf"
                      className="cv-download-btn"
                    >
                      <span className="btn-text">
                        Download CV
                      </span>

                      <span
                        className="btn-icon"
                        aria-hidden="true"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line
                            x1="12"
                            y1="15"
                            x2="12"
                            y2="3"
                          />
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </Col>

              <Col
                lg={5}
                md={12}
                className="home-image text-center mb-4 mb-lg-0"
              >
                {!imageError ? (
                  <img
                    src={homeLogo}
                    alt="Cybersecurity and IT infrastructure illustration"
                    className="img-fluid"
                    onError={() => setImageError(true)}
                  />
                ) : (
                  <div className="image-placeholder">
                    Image unavailable
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Container>
      </section>

      <About />
      <Skills />
      <CyberRange />
      <Projects />
      <Experience />
      <ProfessionalDevelopment />
      <Contact />
    </div>
  );
}

export default Home;